import axios from "axios";

const DEFAULT_API_BASE_URL = "https://backend.luminexadvisors.com/luminex-creds";

export const API_BASE_URL = (
  process.env.REACT_APP_API_URL || DEFAULT_API_BASE_URL
).replace(/\/$/, "");

export const apiClient = axios.create({
  baseURL: API_BASE_URL,
  headers: {
    "Content-Type": "application/json",
  },
});

export const apiPath = (path) => {
  const normalizedPath = path.startsWith("/") ? path : `/${path}`;
  return `${API_BASE_URL}${normalizedPath}`;
};
